export default __webpack_public_path__ + "static/media/bg4.b6f282c2.jpg";